import { useRef, useCallback, useEffect } from 'react';

const useSuperChatScroll = ({ messages, showFeedbackInMessages }) => {
    const messagesEndRef = useRef(null);

    const scrollToBottom = useCallback((immediate = false) => {
        if (immediate) {
            messagesEndRef.current?.scrollIntoView({ behavior: 'auto' });
        } else {
            setTimeout(() => {
                messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
            }, 500);
        }
    }, []);

    useEffect(() => {
        scrollToBottom();
    }, [messages, showFeedbackInMessages, scrollToBottom]);

    return {
        messagesEndRef,
        scrollToBottom
    };
};

export default useSuperChatScroll;
